/* eslint-disable object-curly-newline */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  handleChange,
  handleValidation,
  getValidClass,
  isRequired,
  getFieldKey,
  fieldShouldDisplay,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function TextInput({
  cols = '12',
  autoFocus,
  clone,
  disabled,
  name,
  staticValue,
  className = '',
}) {

  const {
    values,
    form: { form },
    validation,
  } = useSelector(store => store);
  const value = values[name];
  const cloneValue = values[clone];
  const required = isRequired({ form, name, currentValues: values });
  const customLabel = getFieldKey(form, name, 'label');

  const validationRegex = validation[name];
  const defaultLabel = useSelector(store => store.labels[name]);
  const valid = useSelector(store => store.valid[name]);
  const validClass = getValidClass({ valid, required, value });

  const { submittedFlag } = useSelector(store => store.enrollment);

  const isDisabled = (disabled || clone || submittedFlag);

  const classes = ['form-control', (!isDisabled && validClass)].join(' ');

  useEffect(() => {
  }, []);

  useEffect(() => {
    // If the field is cloned, we need to set it's value
    // when the cloned field gets updated instead of when
    // this field gets updated
    if (clone) {
      handleChange({ name, value: cloneValue });
      handleValidation({ value: cloneValue, validationRegex, name, required });
    }
    // if we are setting a static value, we need to make sure the value
    // gets properly set in redux on field load.
    if (staticValue) {
      handleChange({ name, value: staticValue });
      handleValidation({ value: staticValue, validationRegex, name, required });
    }
  }, [clone, cloneValue, staticValue]);

  // if field doesn't exist, or is conditionally not displayed don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  return (
    <div className={`col-md-${cols} ${className}`}>
      <FormLabel name={name} label={customLabel || defaultLabel} required={required} />
      <input
        type="text"
        autoFocus={((valid === undefined) && autoFocus)}
        className={classes}
        id={name}
        onChange={(e) => handleChange({
          value: e.target.value,
          name,
          valid,
          validationRegex,
        })}
        value={staticValue || values[clone || name] || ''}
        disabled={isDisabled}
        onBlur={() => handleValidation({ value, validationRegex, name, required })}
      />
    </div>
  );
}

export default TextInput;
